var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('work-hours',{attrs:{"data":_vm.data,"readonly":true}})}
var staticRenderFns = []

export { render, staticRenderFns }